
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiOwnShipControlI as ObiOwnShipControlIElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-own-ship-control-i.js';
 
 
 

 
 export const ObiOwnShipControlI = createComponent({
   react: React,
   tagName: 'obi-own-ship-control-i',
   elementClass: ObiOwnShipControlIElement,
   events: {
     
   }
  });
 
 